import styled from 'styled-components'
import { StyledH3, theme } from '../../../theme/Global'

export const CustomH3 = styled(StyledH3)`
  color: ${theme.colors.redText};
  text-align: left;
`

export const ContentWrapper = styled.div`
  color: ${theme.colors.text};
  font-size: 15px;
  font-weight: 400;
  padding: 0 25px;

  h1 {
    color: ${theme.colors.darkBlueText};
    font-size: 24px;
    font-weight: 600;
    line-height: 28px;
  }

  h2 {
    color: ${theme.colors.darkBlueText};
    font-size: 20px;
    line-height: 28px;
  }

  h3 {
    color: ${theme.colors.darkBlueText};
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
  }

  h4 {
    color: ${theme.colors.darkBlueText};
    font-size: 15px;
    font-weight: 600;
    line-height: 28px;
  }

  p,
  em {
    font-size: 15px;
    font-weight: 400;
    color: ${theme.colors.text};
  }

  a {
    color: ${theme.colors.blueText};
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;

    & {
      :focus {
        outline: none;
      }
    }
  }
`

export const ExpansionPanelSummaryStyle = {
  fontSize: '18px',
  fontWeight: '600',
  color: theme.colors.darkBlueText
}

export const ExpansionPanelStyle = {
  margin: '10px 0',
  padding: '25px 0 30px 0'
}

export const ExpansionPanelDetailsStyle = {
  margin: 0,
  padding: '0 0 16px 0'
}
